/* unplugin-vue-components disabled */import script from "./CWADetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./CWADetails.vue?vue&type=script&setup=true&lang=ts"

import "./CWADetails.vue?vue&type=style&index=0&id=4e90b788&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e90b788"]])

export default __exports__